import React, { ReactNode } from 'react';
import { Form } from 'react-bootstrap';

interface InputSelectProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  Children: ReactNode | ReactNode[];
  ClassName?: string;
  DefaultValue?: string;
  Feedback?: string;
  HandleChange: (event: any) => void;
  Id: string;
  IsDisabled?: boolean;
  IsInvalid?: boolean;
  IsReadOnly?: boolean;
  IsRequired?: boolean;
  Label?: string;
  Name?: string;
}

const InputSelect = ({
  Children,
  ClassName,
  DefaultValue,
  Feedback,
  HandleChange,
  Id,
  IsDisabled,
  IsInvalid,
  IsReadOnly,
  IsRequired,
  Label,
  Name,
}: InputSelectProps) => {
  return (
    <Form.Group className={ClassName} controlId={Id}>
      {Label && (
        <Form.Label className={IsRequired ? 'required' : ''}>
          {Label}
        </Form.Label>
      )}
      <Form.Select
        autoComplete="off"
        className={IsReadOnly ? 'form-select-readonly' : null}
        defaultValue={DefaultValue}
        disabled={IsDisabled || IsReadOnly}
        id={Id}
        isInvalid={IsInvalid}
        name={Name !== null ? Name : Id}
        onChange={HandleChange}
        required={IsRequired}
      >
        {Children}
      </Form.Select>
      {Feedback && IsInvalid && (
        <Form.Control.Feedback type="invalid">{Feedback}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

InputSelect.defaultProps = {
  ClassName: 'mb-24',
  DefaultValue: null,
  Feedback: null,
  IsDisabled: false,
  IsInvalid: false,
  IsReadOnly: false,
  IsRequired: true,
  Label: null,
  Name: null,
};

export default InputSelect;
export { InputSelect };
export type { InputSelectProps };
